function DotsHorizontal({
  color = 'currentColor',
  size = 13.09,
}: {
  color?: string
  size?: number
}) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 14 14"
      fill="none"
    >
      <path
        d="M7.00036 7.54538C7.3016 7.54538 7.54581 7.30117 7.54581 6.99992C7.54581 6.69868 7.3016 6.45447 7.00036 6.45447C6.69911 6.45447 6.4549 6.69868 6.4549 6.99992C6.4549 7.30117 6.69911 7.54538 7.00036 7.54538Z"
        stroke={color}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.8185 7.54538C11.1198 7.54538 11.364 7.30117 11.364 6.99992C11.364 6.69868 11.1198 6.45447 10.8185 6.45447C10.5173 6.45447 10.2731 6.69868 10.2731 6.99992C10.2731 7.30117 10.5173 7.54538 10.8185 7.54538Z"
        stroke={color}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M3.18217 7.54538C3.48342 7.54538 3.72763 7.30117 3.72763 6.99992C3.72763 6.69868 3.48342 6.45447 3.18217 6.45447C2.88093 6.45447 2.63672 6.69868 2.63672 6.99992C2.63672 7.30117 2.88093 7.54538 3.18217 7.54538Z"
        stroke={color}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export default DotsHorizontal
